// The names a Cookie header (or document.cookie) carries more than once: the
// shared copy beside an old host copy that a write on another subdomain left
// behind.
const duplicateNames = (cookies: string): string[] => {
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  for (const pair of cookies.split(";")) {
    const name = pair.split("=", 1)[0]?.trim();
    if (!name) continue;
    if (seen.has(name)) duplicates.add(name);
    seen.add(name);
  }
  return [...duplicates];
};

export default duplicateNames;
